import { Skeleton, Typography } from "antd";

type Props = {
  isLoading: boolean;
  title?: string;
  children?: React.ReactNode;
};

export const PageTitle = ({ isLoading, title, children }: Props) => {
  if (isLoading) {
    return <Skeleton.Input active={isLoading} style={{ width: "250px" }} />;
  }

  if (title) {
    return (
      <Typography.Title level={3} style={{ margin: 0 }}>
        {title}
      </Typography.Title>
    );
  }

  if (children) {
    return children;
  }

  return null;
};
